import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: () => import('@/views/home/index'),
      meta: {
        title: '首页',
        icon: 'el-icon-s-comment'
      },
    }]
  },
  {
    path: '/SystemManagement',
    component: Layout,
    redirect: '/SystemManagement',
    children: [
      {
        path: 'UserManagement',
        name: 'UserManagement',
        component: () => import('@/views/SystemManagement/UserManagement/UserManagement'),
        meta: { title: '用户管理' }
      },
      {
        path: 'Role',
        name: 'Role',
        component: () => import('@/views/SystemManagement/Role'),
        meta: { title: '角色管理' }
      },
      {
        path: 'UserPopup',
        name: 'UserPopup',
        component: () => import('@/views/SystemManagement/UserManagement/UserPopup'),
        meta: { title: '用户列表' }
      },
      {
        path: 'MenuManagement',
        name: 'MenuManagement',
        component: () => import('@/views/SystemManagement/MenuManagement'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'DictionaryManagement',
        name: 'DictionaryManagement',
        component: () => import('@/views/SystemManagement/DictionaryManagement'),
        meta: { title: '字典管理' }
      },
      {
        path: 'OfficialAccount',
        name: 'OfficialAccount',
        component: () => import('@/views/SystemManagement/OfficialAccount'),
        meta: { title: '公众号管理' }
      },
      {
        path: 'Divisional',
        name: 'Divisional',
        component: () => import('@/views/SystemManagement/Divisional'),
        meta: { title: '部门管理' }
      },
      {
        path: 'OfficeManagemen',
        name: 'OfficeManagemen',
        component: () => import('@/views/SystemManagement/OfficeManagemen'),
        meta: { title: '职务管理' }
      },
      {
        path: 'MyDepartment',
        name: 'MyDepartment',
        component: () => import('@/views/SystemManagement/MyDepartment'),
        meta: { title: '我的部门' }
      }
    ]
  },
  {
    path: '/OrderManagement',
    component: Layout,
    redirect: '/OrderManagement',
    children: [
      {
        path: 'PhysicianOrders',
        name: 'PhysicianOrders',
        component: () => import('@/views/OrderManagement/PhysicianOrders'),
        meta: { title: '问诊订单' }
      },
      {
        path: 'DrugOrders',
        name: 'DrugOrders',
        component: () => import('@/views/OrderManagement/DrugOrders'),
        meta: { title: '药品订单' }
      },
    ]
  },
  {
    path: '/Report',
    component: Layout,
    redirect: '/Report',
    children: [
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/Report/report'),
        meta: { title: '医生月度统计表' }
      },
      {
        path: 'statement',
        name: 'statement',
        component: () => import('@/views/Report/statement'),
        meta: { title: '处方统计表' }
      },
      {
        path: 'consulting',
        name: 'consulting',
        component: () => import('@/views/Report/consulting'),
        meta: { title: '咨询订单' }
      },
      {
        path: 'drugs',
        name: 'drugs',
        component: () => import('@/views/Report/drugs'),
        meta: { title: '药品订单报表' }
      },
      {
        path: 'drugsales',
        name: 'drugsales',
        component: () => import('@/views/Report/drugsales'),
        meta: { title: '药品销量统计' }
      },
      // {
      //   path: 'DrugOrders',
      //   name: 'DrugOrders',
      //   component: () => import('@/views/OrderManagement/DrugOrders'),
      //   meta: {title: '药品订单'}
      // },
    ]
  },
  // {
  //   path: '/Pharmaceutical',
  //   component: Layout,
  //   redirect: '/Pharmaceutical',
  //   children: [{
  //     path: 'Pharmaceutical',
  //     name: 'Pharmaceutical',
  //     component: () => import('@/views/Pharmaceutical/Pharmaceutical'),
  //     meta: {
  //       title: '药品管理',
  //       icon: 'el-icon-shopping-cart-full'
  //     },
  //   }]
  // },
  {
    path: '/Pharmaceutical',
    component: Layout,
    redirect: '/Pharmaceutical',
    children: [
      {
        path: 'Pharmaceutical',
        name: 'Pharmaceutical',
        component: () => import('@/views/Pharmaceutical/Pharmaceutical'),
        meta: { title: '药品列表' }
      },
      {
        path: 'drugstorage',
        name: 'drugstorage',
        component: () => import('@/views/Pharmaceutical/drugstorage'),
        meta: { title: '药品库' }
      },
    ]
  },
  {
    path: '/PharmacyService',
    component: Layout,
    redirect: '/PharmacyService',
    children: [
      // {
      //   path: 'PhysicianOrders',
      //   name: 'PhysicianOrders',
      //   component: () => import('@/views/OrderManagement/PhysicianOrders'),
      //   meta: {title: '问诊订单'}
      // },
      {
        path: 'DrugOrders',
        name: 'DrugOrders',
        component: () => import('@/views/PharmacyService/DrugOrders'),
        meta: { title: '药品订单' }
      },
    ]
  },
  {
    path: '/Article',
    component: Layout,
    redirect: '/Article',
    children: [{
      path: 'article',
      name: 'article',
      component: () => import('@/views/Article/article'),
      meta: {
        title: '文章管理',
        icon: 'el-icon-reading'
      },
    }]
  },
  {
    path: '/HospitalManagement',
    component: Layout,
    redirect: '/HospitalManagement',
    children: [{
      path: 'HospitalManagement',
      name: 'HospitalManagement',
      component: () => import('@/views/HospitalManagement/HospitalManagement'),
      meta: {
        title: '医院管理',
        icon: 'el-icon-office-building'
      },
    }]
  },
  {
    path: '/DoctorManagement',
    component: Layout,
    redirect: '/DoctorManagement',
    children: [
      {
        path: 'doctormanagement',
        name: 'doctormanagement',
        component: () => import('@/views/DoctorManagement/doctormanagement'),
        meta: {
          title: '医生管理',
          icon: 'el-icon-s-custom'
        }
      },
      {
        path: 'doctorschedule',
        name: 'doctorschedule',
        component: () => import('@/views/DoctorManagement/doctorschedule'),
        meta: {
          title: '排班管理',
          icon: 'el-icon-s-grid'
        }
      },
      {
        path: 'docpatientlist',
        name: 'docpatientlist',
        component: () => import('@/views/DoctorManagement/docpatientlist'),
        meta: { title: '患者名单' }
      },
      {
        path: 'Druglist',
        name: 'Druglist',
        component: () => import('@/views/DoctorManagement/Druglist'),
        meta: { title: '药品列表' }
      },
    ]
  },
  {
    path: '/UserManagement',
    component: Layout,
    redirect: '/UserManagement',
    children: [
      {
        path: 'userlist',
        name: 'userlist',
        component: () => import('@/views/UserManagement/userlist'),
        meta: { title: '用户列表' }
      },
      {
        path: 'PatientList',
        name: 'PatientList',
        component: () => import('@/views/UserManagement/PatientList'),
        meta: { title: '患者列表' }
      },
      {
        path: 'Organization',
        name: 'Organization',
        component: () => import('@/views/UserManagement/organization'),
        meta: { title: '组织架构' }
      },
    ]
  },
  {
    path: '/AdministrativeOffices',
    component: Layout,
    redirect: '/AdministrativeOffices',
    children: [{
      path: 'administrative',
      name: 'administrative',
      component: () => import('@/views/AdministrativeOffices/administrative'),
      meta: {
        title: '科室管理',
        icon: 'el-icon-s-opportunity'
      },
    }]
  },
  {
    path: '/LabelManagement',
    component: Layout,
    redirect: '/LabelManagement',
    children: [{
      path: 'label',
      name: 'label',
      component: () => import('@/views/LabelManagement/label'),
      meta: {
        title: '标签管理',
        icon: 'el-icon-s-check'
      },
    }]
  },
  {
    path: '/Prescription',
    component: Layout,
    redirect: '/Prescription',
    children: [
      {
        path: 'Prescriptionlist',
        name: 'Prescriptionlist',
        component: () => import('@/views/Prescription/Prescriptionlist'),
        meta: { title: '处方列表' }
      },
      {
        path: 'print',
        name: 'print',
        component: () => import('@/views/Prescription/module/print'),
        meta: { title: '处方' }
      },
      {
        path: 'Application',
        name: 'Application',
        component: () => import('@/views/Prescription/application'),
        meta: { title: '处方申请' }
      },
      // {
      //   path: 'PrintPrescriptions',
      //   name: 'PrintPrescriptions',
      //   component: () => import('@/views/Prescription/module/PrintPrescriptions'),
      // },
    ]
  },
  {
    path: '/FinancialManagement',
    component: Layout,
    redirect: '/FinancialManagement',
    children: [
      {
        path: 'Settlementrecords',
        name: 'Settlementrecords',
        component: () => import('@/views/FinancialManagement/Settlementrecords'),
        meta: { title: '结算记录' }
      },
      {
        path: 'Showrecords',
        name: 'Showrecords',
        component: () => import('@/views/FinancialManagement/Showrecords'),
        meta: { title: '提现记录' }
      },
      {
        path: 'Security',
        name: 'Security',
        component: () => import('@/views/FinancialManagement/Security'),
        meta: { title: '财务打款' }
      },
    ]
  },
  {
    path: '/Comments',
    component: Layout,
    redirect: '/Comments',
    children: [{
      path: 'Comments',
      name: 'Comments',
      component: () => import('@/views/Comments/Comments'),
      meta: {
        title: '评论管理',
        icon: 'el-icon-message'
      },
    }]
  },
  {
    path: '/MessageCenter',
    component: Layout,
    redirect: '/MessageCenter',
    children: [
      {
        path: 'MessageCenter',
        name: 'MessageCenter',
        component: () => import('@/views/Messagecenter/MessageCenter'),
        meta: {
          title: '消息中心',
          icon: 'el-icon-message'
        },
      },
      {
        path: 'MessageList',
        name: 'MessageList',
        component: () => import('@/views/Messagecenter/MessageList'),
        meta: {
          title: '消息中心',
          icon: 'el-icon-message'
        },
      },
    ]
  },
  {
    path: '/Configuration',
    component: Layout,
    redirect: '/Configuration',
    children: [
      {
        path: 'Platform',
        name: 'Platform',
        component: () => import('@/views/Configuration/Platform'),
        meta: { title: '平台配置' }
      },
      {
        path: 'inquiry',
        name: 'inquiry',
        component: () => import('@/views/Configuration/inquiry'),
        meta: { title: '问诊配置' }
      },
      {
        path: 'Diseaselibrary',
        name: 'Diseaselibrary',
        component: () => import('@/views/Configuration/Diseaselibrary'),
        meta: { title: '疾病库' }
      },
    ]
  },
  {
    path: '/Advertising',
    component: Layout,
    redirect: '/Advertising',
    children: [{
      path: 'advertising',
      name: 'advertising',
      component: () => import('@/views/Advertising/advertising'),
      meta: {
        title: '广告管理',
        icon: 'el-icon-mic'
      },
    }]
  },

  {
    path: '/AuditManagement',
    component: Layout,
    redirect: '/AuditManagement',
    children: [
      {
        path: 'salemanAudit',
        name: 'salemanAudit',
        component: () => import('@/views/AuditManagement/salemanAudit'),
        meta: {
          title: '经纪人审核',
          icon: 'el-icon-s-custom'
        }
      }
    ]
  },

  {
    path: '/OperationManagement',
    component: Layout,
    redirect: '/OperationManagement',
    children: [
      {
        path: 'operationmanagement',
        name: 'operationmanagement',
        component: () => import('@/views/OperationManagement/operationmanagement'),
        meta: {
          title: '消息列表',
          icon: 'el-icon-data-analysis'
        }
      }
    ]
  },
  {
    path: '/feedback',
    component: Layout,
    redirect: '/feedback',
    children: [{
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/views/feedback/feedback'),
      meta: {
        title: '反馈建议',
        icon: 'el-icon-edit'
      },
    }]
  },
  {
    path: '/CustomerService',
    component: Layout,
    redirect: '/CustomerService',
    children: [{
      path: 'CustomerService',
      name: 'CustomerService',
      component: () => import('@/views/CustomerService/CustomerService'),
      meta: {
        title: '门诊客服',
        icon: 'el-icon-headset'
      },
    }]
  },
  {
    path: '/VideoManager',
    component: Layout,
    redirect: '/VideoManager',
    children: [
      {
        path: 'video',
        name: 'video',
        component: () => import('@/views/VideoManager/video'),
        meta: {
          title: '视频管理',
          icon: 'el-icon-office-building'
        },
      }
    ]
  },
  {
    path: '/Applet',
    component: Layout,
    redirect: '/Applet',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/Applet/index'),
        meta: {
          title: '小程序管理',
          icon: 'el-icon-s-tools'
        },
      },
      {
        path: 'OfflineAppointmentOrders',
        name: 'OfflineAppointmentOrders',
        component: () => import('@/views/Applet/OfflineAppointmentOrders'),
        meta: { title: '小程序留电' }
      },
    ]
  },
  {
    path: '/MallManagement',
    component: Layout,
    redirect: '/MallManagement',
    children: [{
      path: 'businessjoin',
      name: 'businessjoin',
      component: () => import('@/views/MallManagement/businessjoin'),
      meta: {
        title: '店铺入驻',
        icon: 'el-icon-s-shop'
      },
    },
    {
      path: 'businesslist',
      name: 'businesslist',
      component: () => import('@/views/MallManagement/businesslist'),
      meta: {
        title: '店铺列表',
        icon: 'el-icon-s-home'
      },
    },
    {
      path: 'businessUser',
      name: 'businessUser',
      component: () => import('@/views/MallManagement/businessUser'),
      meta: {
        title: '店铺成员',
        icon: 'el-icon-s-custom'
      },
    },

    ]
  },
  {
    path: '/MallCommodityManagement',
    component: Layout,
    redirect: '/MallCommodityManagement',
    children: [
      {
        path: 'commodityType',
        name: 'commodityType',
        component: () => import('@/views/MallCommodityManagement/commodityType'),
        meta: {
          title: '商品分类',
          icon: 'el-icon-notebook-2'
        },
      },
      {
        path: 'commodityList',
        name: 'commodityList',
        component: () => import('@/views/MallCommodityManagement/commodityList'),
        meta: {
          title: '商品列表',
          icon: 'el-icon-tickets'
        },
      },
      {
        path: 'commodityAdd',
        name: 'commodityAdd',
        component: () => import('@/views/MallCommodityManagement/commodityAdd'),
        meta: {
          title: '发布商品',
          icon: 'el-icon-circle-plus-outline'
        },
      },
    ]
  },
  {
    path: '/MallOrderManagement',
    component: Layout,
    redirect: '/MallOrderManagement',
    meta: {
      title: '商城订单管理',
      icon: 'el-icon-shopping-cart-2'
    },
    children: [{
      path: 'OrderManagement',
      name: 'OrderManagement',
      component: () => import('@/views/MallOrderManagement/OrderManagement'),
      meta: {
        title: '商城订单列表',
        icon: 'el-icon-shopping-cart-2'
      },
    },
    {
      path: 'OrdertileList',
      name: 'OrdertileList',
      component: () => import('@/views/MallOrderManagement/OrdertileList'),
      meta: {
        title: '商城订单开票',
        icon: 'el-icon-files'
      },
    },
    ]
  },
  {
    path: '/MallDetailCenter',
    component: Layout,
    redirect: '/MallDetailCenter',
    meta: {
      title: '商城数据中心',
      icon: 'el-icon-s-data'
    },
    children: [{
      path: 'changeDetail',
      name: 'changeDetail',
      component: () => import('@/views/MallDetailCenter/changeDetail'),
      meta: {
        title: '交易数据',
        icon: 'el-icon-s-data'
      },
    },
    {
      path: 'followFlowsDetail',
      name: 'followFlowsDetail',
      component: () => import('@/views/MallDetailCenter/followFlowsDetail'),
      meta: {
        title: '流量数据',
        icon: 'el-icon-data-line'
      },
    },
    {
      path: 'operateAllDetail',
      name: 'operateAllDetail',
      component: () => import('@/views/MallDetailCenter/operateAllDetail'),
      meta: {
        title: '经营总览',
        icon: 'el-icon-thumb'
      },
    }
    ]
  },
  {
    path: '/MallAfterSalesManagement',
    component: Layout,
    redirect: '/MallAfterSalesManagement',
    meta: {
      title: '商城售后管理',
      icon: 'el-icon-service'
    },
    children: [{
      path: 'AfterSalesList',
      name: 'AfterSalesList',
      component: () => import('@/views/MallAfterSalesManagement/AfterSalesList'),
      meta: {
        title: '售后订单列表',
        icon: 'el-icon-service'
      },
    },
    {
      path: 'customerService',
      name: 'customerService',
      component: () => import('@/views/MallAfterSalesManagement/customerService'),
      meta: {
        title: '客服服务',
        icon: 'el-icon-headset'
      },
    },

    ]
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js